import { createStructuredSelector } from 'reselect';
import {
  layoutErorStatusCodeSelector,
  cmsTemplateComponentSelector,
} from './selectors';

export default createStructuredSelector({
  CmsTemplateComponent: cmsTemplateComponentSelector,
  layoutError: layoutErorStatusCodeSelector,
});
